// extracted by mini-css-extract-plugin
module.exports = {"suggests":"_9e1425b4d3--suggests--ngVqD","suggest":"_9e1425b4d3--suggest--zQKxX"};